<template>
  <div class="">
    <el-dialog :visible.sync="dialogshow" :before-close="closeDialog" :close-on-click-modal="false"
      :destroy-on-close="true" custom-class="cus_dialog cus_dialogMax" width="1000px">
      <div slot="title" class="flexBetween">
        <span style="color: #ffffff;"><span style="font-weight: 700">{{ formData.title }}</span></span>
      </div>
      <el-form :model="formData" :rules="rules" ref="formData" label-width="120px">
        <div style="color:orangered;text-align: right;" v-if="formData.check_status == 2">
          {{ formData.check_desc }}
        </div>
        <div class="title">
          <span class="numCss">1</span>

          <b class="title1">职位基本信息</b>
          <span class="title2">加*内容，在确认发布成功后，将无法修改</span>
        </div>
        <el-form-item label="公司">{{ firmData.firm_name }}</el-form-item>
        <el-form-item label="职位名称" prop="job_name">
          <el-input style="width: 90%;" v-model="formData.job_name" placeholder="请输入职位名称"></el-input>
        </el-form-item>
        <el-form-item v-if="$store.state.pmid != 220" label="职位类型" prop="job_type">
          <el-cascader v-model="formData.job_type"  :props="{ value: 'id', label: 'type_name' }" :options="options"
            size="small" style="width: 90%;" clearable placeholder="职位类型"></el-cascader>
        </el-form-item>
        <template v-if="$store.state.pmid != 220">
          <el-form-item label="工作城市" prop="city">
            <el-cascader ref="mycascader" v-model="formData.city" :options="cityOptions" size="small" style="width: 90%;"
                         clearable @change="onChangeCity" placeholder="请选择工作城市"></el-cascader>
          </el-form-item>
          <el-form-item label="工作地点" prop="workLocation">

            <div class="flexStart">
              <el-select v-model="formData.word_addr" placeholder="请选择工作地点" @change="changeWorkLocation"
                         style="width:90%;">
                <el-option value="addNew">添加新的工作地点</el-option>
                <el-option v-for="(item, index) in locationList" :key="index" :value="item.location+''"
                           :label="item.location"></el-option>
              </el-select>
              <span style="margin-left: 10px;">
              <el-tooltip class="item" effect="dark" content="若'工作城市'选择全国，'工作地点'请填写公司所在地" placement="bottom-end">
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            </div>

          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="工作地点" prop="city">
            <el-cascader ref="mycascader" v-model="formData.city" :options="cityOptions" size="small" style="width: 90%;"
                         clearable @change="onChangeCity" placeholder="请选择工作城市"></el-cascader>
          </el-form-item>
        </template>
        <el-form-item label="招聘人数" prop="need_num">
          <el-input-number style="width: 200px;" v-model="formData.need_num" :min="1" :max="1000"
            label="请输入招聘人数"></el-input-number>
        </el-form-item>
        <div class="title">
          <span class="numCss">2</span>
          <b class="title1">职位要求</b>
          <span class="title2">我们将通过以下条件，为您精确推荐合适的牛人，请尽量详细填写</span>
        </div>
        <template v-if="$store.state.pmid != 220">
          <el-form-item label="经验和学历" prop="experience">
          <span>
            <el-select style="width:200px" v-model="formData.experience" placeholder="请选择经验">
              <el-option :label="item.param_desc" v-for="(item, idx) in gzjy" :key="idx"
                         :value="item.param_value / 1"></el-option>
            </el-select>
          </span>
            <span style="margin-left:25px">
            <el-select style="width:200px" v-model="formData.eduaction" placeholder="请选择学历">
              <el-option :label="item.param_desc" v-for="(item, idx) in xlyq" :key="idx"
                         :value="item.param_value / 1"></el-option>
            </el-select>
          </span>
          </el-form-item>
          <el-form-item label="外语要求" prop="english_level">
            <el-select style="width:200px" v-model="formData.english_level" placeholder="请选择外语要求">
              <el-option :label="item.param_desc" v-for="(item, idx) in wyyq" :key="idx"
                         :value="item.param_value / 1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计算机要求" prop="computer_level">
            <el-select style="width:200px" v-model="formData.computer_level" placeholder="请选择计算机要求">
              <el-option :label="item.param_desc" v-for="(item, idx) in jsjyq" :key="idx"
                         :value="item.param_value / 1"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="学历要求" prop="eduaction">
            <el-select style="width:200px" v-model="formData.eduaction" placeholder="请选择学历">
              <el-option :label="item.param_desc" v-for="(item, idx) in xlyq" :key="idx"
                         :value="item.param_value / 1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业要求" prop="profession">
            <el-select style="width:200px" v-model="formData.profession" placeholder="请选择专业">
              <el-option :label="item.param_desc" v-for="(item, idx) in professions" :key="idx"
                         :value="item.param_value / 1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="福利待遇" prop="fldy">
            <el-checkbox-group v-model="formData.fldy" @change="handleCheckFldy">
              <el-checkbox v-for="(item, idx) in fldys" :label="item.param_value / 1" :key="idx">{{item.param_desc}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="formData.fldy.indexOf(0) >= 0 " label="福利待遇说明" prop="fldy_desc">
            <el-input type="textarea" v-model="formData.fldy_desc" placeholder="请输入其他福利待遇说明"
                      :autosize="{ minRows: 4, maxRows: 10 }"
                      maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </template>
        <el-form-item label="薪资范围" prop="pay">
          <el-select style="width:200px" v-model="formData.pay" placeholder="请选择薪资范围">
            <el-option :label="item.param_desc" v-for="(item, idx) in xzfw" :key="idx"
              :value="item.param_value / 1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位描述" prop="job_desc">
          <el-input style="width:90%" type="textarea" placeholder="请输入内容" v-model="formData.job_desc" show-word-limit
            :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
        </el-form-item>
        <el-form-item v-if="$store.state.pmid == 220" label="发布时间范围" prop="publish_date_range">
          <el-date-picker
              v-model="formData.publish_date_range"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <p v-if="firmData.email" style="float: right;padding-right: 14px;padding-bottom: 15px;">简历将发送到{{ firmData.email }}
          ，如需更改邮箱，请在『 企业资料』 中修改</p>
        <el-row>
          <el-col :span="22" style="text-align: right;">
            <el-button type="primary" icon="el-icon-s-promotion" @click="saveForm('formData')">保存并发布</el-button>
          </el-col>
        </el-row>
      </el-form>


    </el-dialog>
    <el-dialog :visible.sync="visible" :close-on-click-modal="false" :destroy-on-close="true" custom-class="cus_dialog"
      width="600px">
      <div slot="title" class="flexBetween">
        <span style="color: #ffffff;">添加新的工作地点</span>
      </div>
      <el-form class="">
        <el-form-item label="详细地址">
          <el-autocomplete class="felx_1" v-model="address" :fetch-suggestions="onChangeLocation"
            @change="onChangeLocation" @select="onSelect" placeholder="请输入详细地址" style="width:100%;">
            <template slot="prepend">{{ this.workCityName }}</template>
          </el-autocomplete>
        </el-form-item>
      </el-form>

      <el-amap v-show="mapShow" vid="amapDemo" :zoom="zoom" :center="center" class="amap-demo" :events="events">
        <el-amap-text v-for="(text, index) in texts" :key="'text-' + index" :text="text.text" :offset="text.offset"
          :position="text.position"></el-amap-text>
        <el-amap-marker v-for="(marker, index) in markers" :key="'marker-' + index" :position="marker.position"
          :events="marker.events" :visible="marker.visible" :draggable="marker.draggable" :vid="index"></el-amap-marker>
      </el-amap>
      <el-divider type="horizontal" />
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="cancel">取消</el-button>
        <el-button class="confirm" @click="confirm" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios';

import citys from "@/utils/area.json";
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
export default {
  data() {
    const self = this;
    return {
      dialogshow: true,
      options: [],
      cityOptions: [],
      firmData: {
        firm_name: "",
        email: ""
      },
      formData: {
        title: "",
        job_name: "",
        need_num: 0,
        job_type: null,
        city: "",
        word_addr: "",
        experience: null,
        eduaction: null,
        english_level: null,
        computer_level: null,
        pay: null,
        job_desc: "",
        profession: null,
        fldy: [],
        fldy_desc: null,
        publish_date_range: [],
      },
      qyxz: [],
      xzfw: [],
      xlyq: [],
      gzjy: [],
      wyyq: [],
      jsjyq: [],
      gwshzz: [],
      professions: [],
      fldys: [],
      rules: {
        job_name: [
          { required: true, message: "请输入职位名称", trigger: "blur" },
          { min: 2, max: 15, message: "长度在2 到 15 个字符", trigger: "blur" }
        ],
        // workLocation: [
        //   { required: true, message: "请选择工作地点", trigger: "change" }
        // ],
        job_type: [
          { required: true, message: "请选择职位类型", trigger: "change" }
        ],
        city: [
          { required: true, message: "请选择工作城市", trigger: "change" }
        ],
        need_num: [
          { required: true, message: "请选择招聘人数", trigger: "change" }
        ],
        pay: [{ required: true, message: "请选择薪资范围", trigger: "change" }],
        computer_level: [
          { required: true, message: "请选择计算机要求", trigger: "change" }
        ],
        experience: [
          { required: true, message: "请选择经验", trigger: "change" }
        ],
        eduaction: [
          { required: true, message: "请选择学历", trigger: "change" }
        ],
        english_level: [
          { required: true, message: "请选择外语要求", trigger: "change" }
        ],
        job_desc: [
          { required: true, message: "请填写职位描述", trigger: "blur" }
        ],
        profession: [
          { required: true, message: "请选择专业", trigger: "change" }
        ],
        fldy: [
          { required: true, message: "请选择福利待遇", trigger: "change" }
        ],
        fldy_desc: [
          { required: true, message: "请输入其他福利待遇说明", trigger: "blur" }
        ],
        publish_date_range: [{required: true, message: "请选择发布时间范围", trigger: "change"}],
      },
      visible: false,
      address: '',
      workLocation: '',
      workCityName: undefined,
      locationList: [],
      mapShow: false,
      zoom: 16,
      center: [116.397477, 39.908692],
      events: {
        click(e) {
          let { lng, lat } = e.lnglat;
          self.clickLng = lng;
          self.clickLat = lat;

          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          });
          geocoder.getAddress([self.clickLng, self.clickLat], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                self.$nextTick(() => {
                  self.center = [self.clickLng, self.clickLat];
                  self.markers[0].position = [self.clickLng, self.clickLat];
                  self.texts[0].position = [self.clickLng, self.clickLat];
                  self.texts[0].text = result.regeocode.formattedAddress;
                  self.address = result.regeocode.formattedAddress;
                });
              }
            }
          });
        },
        lng: 0,
        lat: 0
        // },
      },
      markers: [
        {
          position: [116.397477, 39.908692],
          events: {
            // click: () => {
            //   alert('click marker');
            // },
            // dragend: e => {
            //   console.log('---event---: dragend');
            //   this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
            // }
          },
          visible: true,
          draggable: false,
          template: '<span></span>'
        }
      ],
      texts: [
        {
          position: [116.397477, 39.908692],
          text: '天安门',
          offset: [0, -70]
          // events: {
          //   click: () => {
          //     alert('click text');
          //   }
          // }
        }
      ],
      posBoxWidth: 0,//监听盒子宽度
      posBoxId: '',
      locationSource: []
    };
  },
  mounted() {
    this.getComType().then(rr => {
      this.$http.post("/api/zp_job_type_tree", {}).then(res => {
        this.options = res.data.tree;
      });
      this.$http.post("/api/enterprise_info", {}).then(res => {
        this.firmData.firm_name = res.data.firm_name;
        this.firmData.email = res.data.email;
      });
      this.$$parent(this, "formData").then(res => {
        // res.workLocation = res.word_addr
        res.job_type = res.job_type_arr?JSON.parse(res.job_type_arr):[];
        res.city = res.city_arr?JSON.parse(res.city_arr):[];

        this.formData = {...this.formData, ...res};
        if (window.pmid != 220) {
          citys.map(a => {
            a.children && a.children.map(b => {
              delete b.children
            })
          })
        }
        this.cityOptions = citys;

      });
    });
    this.getWorkLocationList()
  },
  methods: {

    getWorkLocationList() {
      this.$http.post("/api/zp_enter_workplace_list", { page: 1, pagesize: 99999 }).then(res => {
        this.locationList = res.data.data

        if (this.locationList.length>0) {
            this.formData.word_addr = this.locationList[0].location;
           
          }
      })
    },
    onChangeCity(value, selectedOptions) {
      this.workCityName = this.$refs["mycascader"].getCheckedNodes()[0].label;
      this.cityStr = this.$refs["mycascader"].getCheckedNodes()[0].pathLabels.join(' ');
      console.log(404, value, this.cityStr)
    },
    changeWorkLocation(e) {
      if (e == 'addNew') {
        this.formData.word_addr = ''
        this.$forceUpdate()
        this.showModal()
        this.mapShow = false;
      }
    },
    showModal() {
      if (this.$refs["mycascader"].getCheckedNodes().length) {
        this.workCityName = this.$refs["mycascader"].getCheckedNodes()[0].label
      }
      if (this.formData.city && this.workCityName) {
        this.visible = true;
        this.formData.workLocation = ''
      } else {
        this.$message.warning('请先选择城市');
        // this.formData.workLocation = ''
        return;
      }
    },
    onChangeLocation(value, callback) {
      this.address = value;
      let locationSource = [];
      $.get('https://restapi.amap.com/v3/assistant/inputtips?output=json&city=' + this.workCityName + '&keywords=' + this.address + '&key=0b5d4c06598b47042b9b5257889f7e26', (res) => {
        if (res.tips) {
          locationSource = res.tips.map(o => { return { value: o.name } })
        }
        this.locationSource = res.tips;
        callback(locationSource);
      })
    },

    onSelect(obj) {
      this.address = obj.value;
      this.locationSource.forEach(element => {
        if (element.name == this.address) {
          if (element.location && element.location.length > 0) {
            this.mapShow = true;
            const locArr = element.location.split(',').map(Number);
            this.center = locArr;
            this.markers[0].position = locArr;
            this.texts[0].position = locArr;
          }
          this.texts[0].text = '<b>' + element.name + '</b></br><span>' + element.address + '</span>';
          this.address = element.name + '(' + element.address + ')';
          this.latLng = element.location;
          return;
        }
      });
    },

    cancel() {
      this.visible = false;
      this.mapShow = false;
      this.address = '';
    },
    confirm() {
    
      if (this.latLng) {
        this.workLocation = this.cityStr.concat(' ', this.address);
        this.$http.post('/api/zp_enter_workplace_edit', {
          lan_lng: this.latLng,
          location: this.workLocation
        })
          .then(res => {
            if (res.data.id) {
              this.$message.success('添加成功');
              this.getWorkLocationList();
            }
          })
          .catch(err => {
            this.$message.error(`addWorkLocation err: ${err.msg}`);
          });
      } else {
        this.$message.error('请选择具体地址');
      }
      this.visible = false;
      this.mapShow = false;
      this.address = '';
    },

    saveForm(formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let formData = {...this.formData}
          /*let info = {};
          info.id = _this.formData.id;
          info.job_name = _this.formData.job_name;
          info.need_num = _this.formData.need_num;
          info.job_type = _this.formData.job_type[
            _this.formData.job_type.length - 1
          ];
          info.job_type_arr = JSON.stringify(_this.formData.job_type)

       
          info.city = _this.formData.city[_this.formData.city.length - 1];
          info.city_arr = JSON.stringify(_this.formData.city)
          info.word_addr = _this.formData.word_addr || null;
          info.experience = _this.formData.experience;
          info.eduaction = _this.formData.eduaction;
          info.english_level = _this.formData.english_level;
          info.computer_level = _this.formData.computer_level;
          info.pay = _this.formData.pay;
          info.job_desc = _this.formData.job_desc;
          info.fldy  = _this.formData.fldy || null;
          info.fldy_desc  = _this.formData.fldy_desc || null;
          info.profession = _this.formData.profession;*/
          formData.job_type_arr = JSON.stringify(formData.job_type)
          formData.job_type = formData.job_type[formData.job_type.length - 1];
          formData.city_arr = JSON.stringify(formData.city)
          formData.city = formData.city[formData.city.length - 1]
          if (formData.publish_date_range) {
            formData.start_time = formData.publish_date_range[0];
            formData.end_time = formData.publish_date_range[1];
          }
          formData.fldy = formData.fldy.length > 0 ? formData.fldy.join(',') : null
          _this.$http.post("/api/zp_job_info_edit", formData).then(res => {
            _this.$message.success(`职位:${_this.formData.job_name} 发布成功!`);
            _this.dialogshow = false
            _this.$$parent(_this, "dialogshow", false);
            _this.$$parent(_this, "getList", false);
          });
        } else {
          return false;
        }
      });
    },
    closeDialog() {
      this.$$parent(this, "dialogshow", false);
    },
    getComType() {
      return new Promise(resolve => {
        let salaryType = window.pmid == 220 ? 'SALARY_RANGE_ZP' : 'SALARY_RANGE'
        this.$http
          .post("/api/sys_param_list", {
            param_type:
              "'ENTER_INFO','" + salaryType + "','EDUACTION','EXPERIENCE','ENGLISH_LEVEL','COMPUTER_LEVEL','GWSHZT','PROFESSIONS','FLDY'",
            used: 0
          })
          .then(res => {
            let qyxz = []; //企业性质
            let xzfw = []; //薪资类型
            let xlyq = []; //学历类型
            let gzjy = []; //工作经验
            let wyyq = []; //外语要求
            let jsjyq = []; //计算机要求
            let gwshzz = []; //计算机要求
            let professions = []; //计算机要求
            let fldy = []
            for (let item of res.data) {
              if (item.param_type == "ENTER_INFO") {
                qyxz.push(item);
              }
              if (item.param_type == salaryType) {
                if (item.param_value == 0) item.param_desc = '面议'
                xzfw.push(item);
              }
              if (item.param_type == "EDUACTION") {
                xlyq.push(item);
              }
              if (item.param_type == "EXPERIENCE") {
                gzjy.push(item);
              }
              if (item.param_type == "ENGLISH_LEVEL") {
                wyyq.push(item);
              }
              if (item.param_type == "COMPUTER_LEVEL") {
                jsjyq.push(item);
              }
              if (item.param_type == "GWSHZT") {
                gwshzz.push(item);
              }
              if (item.param_type == "PROFESSIONS") {
                professions.push(item);
              }
              if (item.param_type == 'FLDY') {
                fldy.push(item);
              }
            }
            this.qyxz = qyxz;
            this.xzfw = xzfw;
            this.xlyq = xlyq;
            this.gzjy = gzjy;
            this.wyyq = wyyq;
            this.jsjyq = jsjyq;
            this.gwshzz = gwshzz;
            this.professions = professions;
            this.fldys = fldy
            resolve();
          });
      });
    },
    handleCheckFldy(val) {
      if (val.indexOf(0) < 0) {
        this.formData.fldy_desc = null;
      }
    },
  }
};
</script>

<style lang="less">
.cus_dialogMax {
  .el-dialog__body {
    height: 85vh;
  }
}
</style>
<style lang="less" type="text/less" scoped>
.locationModel,
.typeModel {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .addLocation {
    width: 90%;
    max-width: 600px;
    padding: 15px 25px;
    background-color: #ffffff;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);

    .ant-form-item {
      padding-left: 0;
    }

    h5 {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 20px;
    }

    .fixCity {
      display: block;
      float: left;
      height: 40px;
      padding: 0 8px;
      border: 1px solid#d9d9d9;
      border-right: 0;
      line-height: 40px;
      background-color: #fafafa;
      color: rgba(0, 0, 0, 0.65);
      position: relative;
      top: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      font-size: 15px;
      overflow: hidden;
    }

    .ant-select {
      width: 390px;

      /deep/ .ant-input {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        font-size: 15px;
      }

      /deep/ .ant-input::-webkit-input-placeholder {
        color: #aaaaaa;
      }
    }

    .bntCon {
      display: flex;
      justify-content: flex-end;

      .cancel {
        margin-right: 8px;
      }
    }
  }

  .el-vue-amap-container {
    height: 300px;

    /deep/ .amap-overlay-text-container {
      padding: 5px 10px;
    }
  }

  .typeCon {
    max-height: 520px;
    overflow-y: auto;
    width: 100%;
    max-width: 900px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    overflow: visible;

    h5 {
      font-weight: bold;
      font-size: 16px;
      padding: 0 24px;
      line-height: 48px;
      position: relative;
      margin-bottom: 0;

      /deep/ .anticon-close {
        color: #909399;
        font-weight: normal;
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .typeList {
      padding: 0 0 100px;
      margin: 0;
      height: calc(520px - 48px);
      overflow-y: auto;

      >li {
        padding: 10px 24px;
        list-style: none;
        display: flex;
        align-items: center;

        b {
          display: block;
          width: 130px;
          flex: 1;
        }

        ul {
          margin-left: 10px;
          padding-left: 0;
          flex: 5;

          li {
            cursor: pointer;
            display: inline-block;
            list-style: none;
            margin-right: 20px;
            line-height: 32px;
            position: relative;
            /*.suspensionBox {*/
            /*  width: 450px;*/
            /*  cursor: pointer;*/
            /*  background-color: #ffffff;*/
            /*  box-shadow: 2px 2px 15px #909399;*/
            /*  padding: 10px 20px;*/

            /*  div {*/
            /*    display: inline-block;*/
            /*    margin-right: 20px;*/
            /*  }*/
            /*}*/

            .anticon {
              color: #3378fa;
              position: relative;
              top: 1px;
            }
          }
        }
      }

      >li:nth-child(odd) {
        background-color: #f9fafb;
      }

      >li:nth-child(even) {
        background-color: #ffffff;
      }
    }
  }
}

.numCss {
  font-size: 40px;
  position: absolute;
  color: #3378fa;
  margin-top: -4px;
  left: 0px;
}

.title {
  position: relative;
  padding-left: 36px;
  margin-bottom: 15px;
}

.title1 {
  display: block;
  font-size: 16px;
  font-weight: 900;
}

.title2 {
  font-weight: 400;
  font-size: 12px;
  color: #909399;
}
</style>

